import { createEvent, createStore, sample } from 'effector'
import { fx } from '../../../libs/request'
import { addressCheckSubmitted } from '../check/model'
import { WalletGuardWallet } from '../types'
import { WalletGuardPaymentSystemsResponse, WalletGuardStats } from './types'

export const dashboardRequested = createEvent()

export const getDashboardFx = fx<void, WalletGuardStats>({
  method: 'GET',
  // The shared CRM base URL already includes /v1.
  url: '/wallet-guard/dashboard/stats',
})

export const $stats = createStore<WalletGuardStats | null>(null)
  .on(getDashboardFx.doneData, (_, response) => response.body)
  .reset(getDashboardFx)

export const $hasError = createStore(false)
  .on(getDashboardFx.fail, () => true)
  .reset(getDashboardFx)

sample({
  clock: dashboardRequested,
  source: getDashboardFx.pending,
  filter: (pending) => !pending,
  fn: () => ({}),
  target: getDashboardFx,
})

export const paymentSystemsRequested = createEvent()

export const getPaymentSystemsFx = fx<void, WalletGuardPaymentSystemsResponse>({
  method: 'GET',
  url: '/wallet-guard/payment-systems',
})

export const $paymentSystems = createStore<string[]>([]).on(
  getPaymentSystemsFx.doneData,
  (_, response) => response.body.items,
)

sample({
  clock: paymentSystemsRequested,
  fn: () => ({}),
  target: getPaymentSystemsFx,
})

// Ручная проверка кошелька переиспользует проверку адреса со страницы «Проверка».
export const walletCheckRequested = createEvent<WalletGuardWallet>()
export const walletCheckClosed = createEvent()

export const $checkedWallet = createStore<WalletGuardWallet | null>(null)
  .on(walletCheckRequested, (_, wallet) => wallet)
  .reset(walletCheckClosed)

sample({
  clock: walletCheckRequested,
  fn: ({ network, address }) => ({ network, walletAddress: address }),
  target: addressCheckSubmitted,
})
